import Handler from '@/core/domain/usecase/handler';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import { Place } from '../../domain/model/place';

export interface CreatePlaceRepository {
  (data: object): Promise<Place>
}

const createPlaceRepository = (axios: AxiosInstance): CreatePlaceRepository => async (data: object) => {
  try {
    const response: AxiosResponse = await axios.post(`/place`,
      data
    )
    return response.data
  } catch (err: any | AxiosError) {
    if (err.isAxiosError) {
      throw new Handler().trataErro(err)
    } else {
      throw err
    }
  }
}

export default createPlaceRepository

